export const square = function (ctx : any) {
    ctx.save();
    ctx.strokeStyle = "rgba(0,0,0,0)";
    ctx.miterLimit = 4;   
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(15, 15);
    ctx.lineTo(185, 15);
    ctx.bezierCurveTo(185, 15, 185, 15, 185, 15);
    ctx.lineTo(185, 185);
    ctx.bezierCurveTo(185, 185, 185, 185, 185, 185);
    ctx.lineTo(15, 185);
    ctx.bezierCurveTo(15, 185, 15, 185, 15, 185);
    ctx.lineTo(15, 15);
    ctx.bezierCurveTo(15, 15, 15, 15, 15, 15);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    ctx.restore();
}